import React, { useEffect } from 'react';
import { Dashboard } from './Components/Dashboard/Dashboard';
import { EnvironmentToggle } from './Components/EnvironmentToggle/EnvironmentToggle';
import { makeStyles } from '@fluentui/react-components';
import { Navigate, Route, Routes } from 'react-router-dom';

const useStyles = makeStyles({
  appContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    width: '100%',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 24px',
    borderBottom: '1px solid #e5e5e5',
    backgroundColor: '#ffffff',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  logoText: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#333333',
    letterSpacing: '0.5px',
  },
  dashboardWrapper: {
    flex: 1,
    overflow: 'hidden',
  },
});

const LeelaLifeLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="149"
      height="17"
      viewBox="0 0 149 17"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.29434 2.89996L2.13631 4.88679C2.13533 4.88908 2.13333 4.89509 2.13333 4.90419C2.13333 4.91365 2.13549 4.91977 2.13642 4.92184L2.13753 4.92265L5.85004 7.35128L9.68555 4.95233L6.414 2.88423L6.39499 2.87192C6.14125 2.70388 5.7345 2.65767 5.29434 2.89996ZM2.13632 12.304L5.99666 9.87218L9.70589 12.2604L6.43812 14.3261C5.99829 14.5679 5.59192 14.5216 5.33835 14.3537L5.31739 14.3401L2.13631 12.3388C2.13533 12.3365 2.13333 12.3305 2.13333 12.3214C2.13333 12.3123 2.13534 12.3063 2.13632 12.304ZM16.9312 14.2262L13.6791 12.2438L17.4462 9.8184L21.2237 12.198C21.2247 12.2003 21.2267 12.2063 21.2267 12.2154C21.2267 12.2245 21.2247 12.2305 21.2237 12.2328L18.0657 14.2197C17.6255 14.462 17.2188 14.4157 16.965 14.2477C16.9539 14.2403 16.9426 14.2332 16.9312 14.2262ZM21.2237 4.9216L17.4377 7.30655L13.6741 4.95256L16.9219 2.89947C17.3617 2.65773 17.7681 2.704 18.0217 2.87192L18.0426 2.88545L21.2237 4.88679C21.2247 4.88908 21.2267 4.89509 21.2267 4.90419C21.2267 4.91331 21.2247 4.91932 21.2237 4.9216ZM7.56786 1.10172C6.54681 0.431655 5.25998 0.478503 4.21745 1.07029C4.20343 1.07825 4.18959 1.08652 4.17594 1.09511L0.975944 3.10835L0.954986 3.12188C-0.318329 3.96514 -0.318329 5.84324 0.954986 6.68649L3.9549 8.64898L0.975422 10.5259L0.954986 10.5391C-0.318329 11.3824 -0.318329 13.2605 0.954986 14.1037L0.975944 14.1172L4.16655 16.1246C5.18743 16.7939 6.47372 16.7469 7.51588 16.1553C7.53057 16.147 7.54506 16.1383 7.55933 16.1293L11.6903 13.5179L15.8002 16.0232C16.82 16.6877 18.1028 16.6396 19.1425 16.0493C19.1566 16.0414 19.1704 16.0331 19.1841 16.0245L22.3841 14.0113L22.405 13.9977C23.6783 13.1545 23.6783 11.2764 22.405 10.4331L22.3846 10.4199L19.4318 8.55981L22.3846 6.69969L22.405 6.68649C23.6783 5.84324 23.6783 3.96514 22.405 3.12188L22.3841 3.10835L19.1935 1.10105C18.1726 0.431686 16.8863 0.478702 15.8441 1.07029C15.8294 1.07863 15.8149 1.08731 15.8007 1.09633L11.68 3.70121L7.56786 1.10172ZM7.9009 8.57283L11.6796 11.0058L15.4584 8.57283L11.6796 6.20938L7.9009 8.57283ZM68.914 1.03958V4.09025H60.3807V6.97025H68.2954V9.87158H60.3807V12.9222H69.0634V15.9729H56.9674V1.03958H68.914ZM74.2769 12.9223V1.03964H70.8636V15.973H81.8716V12.9223H74.2769ZM92.7716 1.03964L98.9156 15.973H94.8623L93.6889 13.029H87.4383L86.2863 15.973H82.2329L88.3343 1.03964H92.7716ZM90.5529 4.81564L88.3556 10.3196H92.7716L90.5529 4.81564ZM108.322 12.9223V1.03964H104.908V15.973H115.916V12.9223H108.322ZM134.432 4.09031V1.03964H122.976V15.973H126.389V10.469H133.728V7.56764H126.389V4.09031H134.432ZM148.159 4.09031V1.03964H136.212V15.973H148.308V12.9223H139.626V9.87164H147.54V6.97031H139.626V4.09031H148.159ZM120.843 1.06097V15.973H117.43V1.06097H120.843ZM55.0173 4.09031V1.03964H43.0707V15.973H55.1667V12.9223H46.484V9.87164H54.3987V6.97031H46.484V4.09031H55.0173ZM33.9621 1.03964V12.9223H41.5568V15.973H30.5488V1.03964H33.9621Z"
        fill="#333333"
      />
    </svg>
  );
};

export const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<InternalPortalApp />} />
      <Route path="/privacy" element={<InternalPortalApp />} />
      <Route path="/privacy-policy" element={<InternalPortalApp />} />
      <Route path="/terms" element={<InternalPortalApp />} />
      <Route path="/terms-of-service" element={<InternalPortalApp />} />
      <Route path="/oauth/callback/:provider" element={<InternalPortalApp />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

const InternalPortalApp: React.FC = () => {
  const styles = useStyles();
  const [clickCount, setClickCount] = React.useState(0);
  const clickTimerRef = React.useRef<NodeJS.Timeout | null>(null);

  // Easter egg: Click logo 7 times to unlock impersonation
  const handleLogoClick = () => {
    setClickCount((prev) => {
      const newCount = prev + 1;

      // Reset timer on each click
      if (clickTimerRef.current) {
        clearTimeout(clickTimerRef.current);
      }

      // Reset count after 2 seconds of inactivity
      clickTimerRef.current = setTimeout(() => {
        setClickCount(0);
      }, 2000);

      // Unlock impersonation on 7 clicks
      if (newCount === 7) {
        sessionStorage.setItem('impersonation_unlocked', 'true');

        // Dispatch event for Dashboard to show Impersonation tab
        window.dispatchEvent(new CustomEvent('impersonation-unlocked'));

        return 0; // Reset count
      }

      return newCount;
    });
  };

  // Check for OAuth callback on mount
  useEffect(() => {
    // Clear impersonation unlock on page load
    sessionStorage.removeItem('impersonation_unlocked');

    const urlParams = new URLSearchParams(window.location.search);
    const path = window.location.pathname;

    console.log('[App.tsx] Current path:', path);
    console.log('[App.tsx] URL params:', Object.fromEntries(urlParams));

    const isGoogleCallback = path.includes('/oauth/callback/google');
    const isMicrosoftCallback = path.includes('/oauth/callback/microsoft');
    const hasOAuthParams = urlParams.has('code') && urlParams.has('state');

    console.log('[App.tsx] isGoogleCallback:', isGoogleCallback);
    console.log('[App.tsx] isMicrosoftCallback:', isMicrosoftCallback);
    console.log('[App.tsx] hasOAuthParams:', hasOAuthParams);

    if ((isGoogleCallback || isMicrosoftCallback) && hasOAuthParams) {
      const provider = isGoogleCallback ? 'google' : 'microsoft';
      console.log('[App.tsx] Detected OAuth callback for provider:', provider);
      console.log('[App.tsx] Dispatching navigate-to-calendar event first');

      // First, navigate to Calendar tab (so Calendar component gets mounted)
      window.dispatchEvent(
        new CustomEvent('navigate-to-calendar', {
          detail: { view: 'oauth-callback' },
        })
      );
      console.log('[App.tsx] navigate-to-calendar event dispatched!');

      // Then, after a delay to allow Calendar to mount, dispatch OAuth callback event
      setTimeout(() => {
        console.log('[App.tsx] Dispatching navigate-to-oauth-callback event');
        window.dispatchEvent(
          new CustomEvent('navigate-to-oauth-callback', {
            detail: { provider },
          })
        );
        console.log('[App.tsx] navigate-to-oauth-callback event dispatched!');
      }, 500); // Increased delay to allow lazy-loaded Calendar component to mount
    }
  }, []);

  return (
    <div className={styles.appContainer}>
      <header className={styles.header}>
        <div
          className={styles.logoContainer}
          onClick={handleLogoClick}
          style={{ userSelect: 'none' }}
        >
          <LeelaLifeLogo />
          <span className={styles.logoText}>Internal</span>
        </div>
        <EnvironmentToggle />
      </header>

      <div className={styles.dashboardWrapper}>
        <Dashboard />
      </div>
    </div>
  );
};

export default App;
